import React, { useMemo } from 'react'

import { Spinner } from '@/components/ui'
import { useDocumentStore } from '@/features/document'
import {
  useDocumentMeta,
  useDocumentViewer,
} from '@/features/view-tfl-uploaded/hooks'
import { isHTMLDocument, isPDFDocument } from '@/utils'

import { HTMLViewer } from './HTMLViewer'
import { PDFViewer } from './PDFViewer'

type DocumentViewerProps = {
  documentId: string
}

export const DocumentViewer: React.FC<DocumentViewerProps> = ({
  documentId,
}) => {
  const versionIdByDocumentId = useDocumentStore(
    (state) => state.versionIdByDocumentId
  )
  const versionId = versionIdByDocumentId[documentId]

  const { isLoading, error, refetch } = useDocumentViewer(
    documentId,
    versionId || undefined
  )

  const meta = useDocumentMeta(documentId)

  const isHtmlFileResult = useMemo(
    () => isHTMLDocument(meta?.fileName || ''),
    [meta]
  )

  const isPdfFileResult = useMemo(
    () => isPDFDocument(meta?.fileName || ''),
    [meta]
  )

  if (isHtmlFileResult) {
    return (
      <HTMLViewer
        documentId={documentId}
        isLoading={isLoading}
        error={error}
        refetch={refetch}
      />
    )
  }

  if (isPdfFileResult) {
    return (
      <PDFViewer
        documentId={documentId}
        isLoading={isLoading}
        error={error}
        refetch={refetch}
        meta={meta}
      />
    )
  }

  if (isLoading) {
    return (
      <div className="flex items-center justify-center p-8">
        <Spinner />
      </div>
    )
  }
  return <div>Unsupported file type</div>
}
